import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, Phone, ArrowLeft } from "lucide-react";

var PHONE_NUMBER = "+7 (812) 313-98-98";
var PHONE_HREF = "tel:+78123139898";

export default function ThankYouPage() {
  var navigate = useNavigate();

  useEffect(function () {
    // Яндекс.Метрика — замените 99999999 на реальный ID
    if (window.ym) {
      window.ym(108320505, "reachGoal", "thank_you_page");
    }
    // Google Analytics (placeholder)
    if (window.gtag) {
      window.gtag("event", "conversion", { event_category: "form" });
    }
  }, []);

  return (
    <div data-testid="thank-you-page" className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center animate-fade-in-up">
        <div className="w-20 h-20 rounded-full bg-brand-100 flex items-center justify-center mx-auto mb-8">
          <CheckCircle className="w-10 h-10 text-brand-700" />
        </div>

        <h1 data-testid="thank-you-heading" className="font-heading text-3xl md:text-4xl font-bold mb-4">
          Спасибо за заявку!
        </h1>

        <p className="text-lg text-slate-500 leading-relaxed mb-8">
          Мы получили ваши ответы и подготовим индивидуальный расчёт стоимости.
          Наш специалист перезвонит вам в течение 15 минут.
        </p>

        <div className="bg-brand-50 rounded-2xl p-6 mb-8 border border-brand-100">
          <p className="text-base font-medium mb-3">
            Если хотите связаться прямо сейчас:
          </p>
          <a href={PHONE_HREF} data-testid="thank-you-phone" className="inline-flex items-center gap-2 text-xl font-bold text-brand-600 hover:text-brand-700 transition-colors">
            <Phone className="w-5 h-5" />
            {PHONE_NUMBER}
          </a>
          <p className="text-sm text-slate-500 mt-2">info@nasha-stoma.ru</p>
        </div>

        <button
          data-testid="thank-you-back"
          onClick={function () { navigate("/"); }}
          className="h-12 px-8 text-base rounded-full border-2 border-slate-200 hover:border-brand-600 hover:text-brand-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Вернуться на главную
        </button>
      </div>
    </div>
  );
}
